import StatusIndicator from './StatusIndicator';

export default StatusIndicator;
